import { CommandRequestType } from "../connection/commandRequestType";
import { ICommandParameters } from "../connection/iCommandParameters";
import { ICommandResponse } from "../connection/iCommandResponse";
import { IRequestCommand } from "../connection/iRequestCommand";
import { ErrorDetails } from "../connection/interfaces/apiInterfaces";
import { MagiisUserTypeEnum } from "../enum/magiisUserType.enum";


export class LogInCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  ICommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'auth/login';
  override _replaceDefaultHeader = true;
  override _canAddCustomHeaders = true;
  override _needAuthenticate = false;
}

export interface ILogInCommandParameters extends ICommandParameters {
  username: string;
  password: string;
}

export interface ILogInResponse extends ICommandResponse {
  userId: string;
  token: string;
  userPrivileges: Array<any>;
  sometimeEntered: boolean;
  userType: MagiisUserTypeEnum;
}
